module.exports = __webpack_public_path__ + "static/media/sort.9494bbfa.svg";